var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "MediaQueryProvider",
    { attrs: { queries: { mobile: "(max-width: 680px)" } } },
    [_c("router-view")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }